import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { seeFn } from 'api/approval/search';
// import timeLine from '@/components/timeLine'
var iconType = new Map([[0, 'el-icon-circle-check'], [1, 'el-icon-more'], [2, '']]);
export default {
  // components: {
  //   timeLine
  // },
  data: function data() {
    return {
      visible: false,
      workflowApproval: {},
      list: [],
      stream: []
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init(item) {
      this.visible = true;
      this.getData(item);
    },
    getColor: function getColor(state) {
      return {
        0: '#2FC25B',
        1: '#FFA015',
        // 待审批 橙色
        2: '#2FC25B',
        // 已同意 绿色
        3: '#F85656',
        // 已驳回 红色
        4: '#909399',
        // 已撤销 灰色
        6: '#F85656',
        // 已拒绝撤销 红色
        7: '#2FC25B' // 已同意 绿色
      }[state || 0];
    },
    handleOpen: function handleOpen(key, index, value) {
      this[key][index] = value;
    },
    getData: function getData(item) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!item || !item.audit_id)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", false);
            case 2:
              _context.next = 4;
              return seeFn({
                audit_id: item.audit_id,
                audit_type: Number(item && item.type ? item.type : 0)
              });
            case 4:
              res = _context.sent;
              if (res && res.code === 1) _this.list = res.data;
              _this.stream = [].concat(_toConsumableArray(res.data.stream), _toConsumableArray(res.data.cancel_stream)).map(function (v, index) {
                v.iconName = iconType.get(v.is_ok) || '';
                v.staff_info_id_more = v.staff_info_id; // .length > 2 ? v.staff_info_id.slice(2) : [];
                // 1收起， 2展开， -1 不展示按钮
                var value = v.approval_info.approvalList && v.approval_info.approvalList.length > 1 ? 1 : -1;
                _this.$set(_this.workflowApproval, index, value);
                return v;
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};